module.exports = __webpack_public_path__ + "img/open-mouth.7b79649b.svg";